/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./lcptracker-redirect.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./lcptracker-redirect.component";
import * as i3 from "@ngrx/store";
import * as i4 from "@angular/router";
var styles_LcpTrackerRedirectComponent = [i0.styles];
var RenderType_LcpTrackerRedirectComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_LcpTrackerRedirectComponent, data: {} });
export { RenderType_LcpTrackerRedirectComponent as RenderType_LcpTrackerRedirectComponent };
export function View_LcpTrackerRedirectComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
export function View_LcpTrackerRedirectComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-lcptracker-redirect", [], null, null, null, View_LcpTrackerRedirectComponent_0, RenderType_LcpTrackerRedirectComponent)), i1.ɵdid(1, 114688, null, 0, i2.LcpTrackerRedirectComponent, [i3.Store, i4.ActivatedRoute], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var LcpTrackerRedirectComponentNgFactory = i1.ɵccf("app-lcptracker-redirect", i2.LcpTrackerRedirectComponent, View_LcpTrackerRedirectComponent_Host_0, {}, {}, []);
export { LcpTrackerRedirectComponentNgFactory as LcpTrackerRedirectComponentNgFactory };
